export type DraggableListProps = {
    // example prop
    foo: string;
};
